/*=========================================================================================
  File Name: locations.js
  Description: Vuex store for getting locations
==========================================================================================*/
//imports
import axios from "axios";

// initial state
const state = {
    locations: [],
};

// getters
const getters = {
    getLocations: (state) => {
        return state.locations;
    },
};

// actions
const actions = {
    fetchLocations({ commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get("api/locations")
                .then((res) => {
                    setTimeout(() => resolve(res.data), 250);
                    commit("FETCH_LOCATIONS", res.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

// mutations
const mutations = {
    FETCH_LOCATIONS(state, data) {
        state.locations = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
